import { useGetWorkspacesForDuplicationQuery } from '@sketch/gql-types'
import { useCheckCurrentAuthorizationForWorkspace } from '../../sso/operations/useCheckCurrentAuthorizationForWorkspace'
import { getEligibleWorkspacesForDuplication } from '../utils/getEligibleWorkspacesForDuplication'
import { ShareWithoutVersion } from '../../versioning'
import { useUserSignedIn } from '@sketch/modules-common'

export const useCanDuplicateToWorkspace = (
  sourceWorkspaceIdentifier: string,
  sharePublicAccessLevel: ShareWithoutVersion['publicAccessLevel'],
  shareUserCanInspect: ShareWithoutVersion['userCanInspect']
) => {
  const isSignedIn = useUserSignedIn()
  const { checkAuthorization } = useCheckCurrentAuthorizationForWorkspace()
  const {
    loading: getWorkspacesLoading,
    data: getWorkspacesData,
    error: getWorkspacesError,
  } = useGetWorkspacesForDuplicationQuery({
    skip: !isSignedIn,
  })

  if (getWorkspacesLoading)
    return { loading: true, error: undefined, data: undefined }

  if (getWorkspacesError || !getWorkspacesData)
    return { loading: false, error: getWorkspacesError, data: undefined }

  const workspaces = getWorkspacesData!.me.workspaces
  const { userCanDuplicate } = getEligibleWorkspacesForDuplication(
    workspaces,
    sourceWorkspaceIdentifier,
    sharePublicAccessLevel,
    { hasAccessToWorkspaceCheckFn: checkAuthorization }
  )
  const canDuplicate = isSignedIn && shareUserCanInspect && userCanDuplicate

  return { loading: false, error: undefined, data: { canDuplicate } }
}
